import { DateTime } from 'luxon';
import { useMemo } from 'react';

interface TimeFilter {
  start: string
  end: string
}

function useTimeFilter(time: string, timezone = 'local') {
  return useMemo<TimeFilter | undefined>(() => {
    const now = DateTime.now().setZone(timezone);
    if (time === 'preset#today') {
      return { end: now.endOf('day').toISO()!, start: now.startOf('day').toISO()! };
    }
    if (time === 'preset#yesterday') {
      const yesterday = now.minus({ day: 1 });
      return { end: yesterday.endOf('day').toISO()!, start: yesterday.startOf('day').toISO()! };
    }
    if (time === 'preset#last_week') {
      return { end: now.endOf('week').toISO()!, start: now.startOf('week').toISO()! };
    }
    if (time.startsWith('month#')) {
      const monthStart = time.split('#')[1];
      return { end: DateTime.fromISO(monthStart).endOf('month').toISO()!, start: monthStart };
    }
    return undefined;
  }, [time, timezone]);
}

export default useTimeFilter;
